module.exports = __webpack_public_path__ + "873e79fab3f64c9619c8997b87f333f0.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/netzbuehne03.jpg
// module id = 671
// module chunks = 0